class SpeechTerapyResultsAPI {
    checkStatus(response) {
        switch (response.status) {
            case 500:
                throw new Error(`${response.status} - Server Error!`);
            case 403:
                throw new Error(`${response.status} - Unhautorized!`);
            default:
                console.log("Success Response");
                break;
        }
    }

    async listActualFormats() {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}formato-resultados-fonoaudiologia/listar`;
        await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                'responseType': 'arraybuffer',
            }
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }
        ).then(formats => {
            datos = formats;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

    async createFormat(dataSend) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}formato-resultados-fonoaudiologia/create`;
        await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                'responseType': 'arraybuffer',
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }
        ).then(format => {
            datos = format.formato;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

    async updateFormat(dataSend) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}formato-resultados-fonoaudiologia/update`;
        await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                'responseType': 'arraybuffer',
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }
        ).then(format => {
            datos = format.formato;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

    async deleteFormat(dataSend) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}formato-resultados-fonoaudiologia/delete`;
        await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                'responseType': 'arraybuffer',
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }
        ).then(format => {
            datos = format;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

}

export default new SpeechTerapyResultsAPI();